import _ from 'lodash';
import { View } from 'backbone.marionette';
import Backbone from 'backbone';

import lazyLoadView from '@/util/lazyLoadView';
import showErrorMessage from '@/util/showErrorMessage';
import Roles from '@/enums/Roles';

import loadSearchFields from '../../../login/loaders/SearchFieldsViewLoader';
import AssessmentCRSGridView from '../../../assessment/views/AssessmentCRSGridView/AssessmentCRSGridView';
import GetAllRegions from '../../services/GetAllRegions';
import SearchInternalUser from '../../services/SearchInternalUser';

import tmplSearchUsersModalView from './SearchUsersModalView.hbs';

const SearchUsersModalView = View.extend({
  template: tmplSearchUsersModalView,

  className: 'search-users-modal-view',

  ui: {
    searchFields: '.search-fields',
    userGrid: '.user-grid',
    btnDone: '.btn-done'
  },

  regions: {
    searchFields: '@ui.searchFields',
    userGrid: '@ui.userGrid'
  },

  childViewEvents: {
    'search:response': 'onSearchResponse',
    'search:error': 'onSearchError',
    'search:reset': 'onSearchReset'
  },

  events: {
    'click @ui.btnDone': 'onClickDone'
  },

  onRender() {
    this.showSearchFieldsView();
    this.showUserGridView();
  },

  showSearchFieldsView() {
    const searchFields = this.getSearchFields();
    const searchService = this.getSearchService();

    this.showChildView(
      'searchFields',
      lazyLoadView(() => loadSearchFields(searchFields, searchService))
    );
  },

  showUserGridView() {
    const gridView = this.getGridView();
    const model = new Backbone.Model({});

    this.userGridView = new gridView({ model });
    this.showChildView('userGrid', this.userGridView);
  },

  onSearchResponse(response) {
    this.handleResponse(response);
    this.userGridView.collection.fullCollection.reset(response);
  },

  onSearchReset(e) {
    e?.preventDefault();
    this.userGridView.collection.fullCollection.reset();
  },

  async onClickDone(e) {
    e.preventDefault();

    const selectedRows = _.filter(this.userGridView.viewGrid.getSelectedModels(), (model) => {
      return !!model;
    });

    if (selectedRows.length < 1) {
      this.showNoUserSelectionError();
      return;
    }

    if (selectedRows.length > 1) {
      this.showMultipleUserSelectionError();
      return;
    }

    const selectedUser = selectedRows[0].toJSON();
    this.triggerMethod('modal:close', selectedUser);
  },

  onSearchError() {
    showErrorMessage({
      errorCode: 'searchError',
      errorTitle: 'Search Error',
      errorMessage: 'An error occurred while during user search. Try again or contact an administrator if your issue persists.'
    });
  },

  showNoUserSelectionError() {
    showErrorMessage({
      errorCode: 'noUserSelectionError',
      errorTitle: 'Selection Error',
      errorMessage: 'A User must be selected.'
    });
  },

  showMultipleUserSelectionError() {
    showErrorMessage({
      errorCode: 'multipleUserSelectionError',
      errorTitle: 'Selection Error',
      errorMessage: 'Only a single User may be selected.'
    });
  },

  getSearchFields() {
    return [
      {
        id: 'crs-name-search-field',
        name: 'name',
        class: 'InputSearchField',
        placeholder: 'CRS Name'
      },
      {
        id: 'crs-region-search-field',
        name: 'crsRegion',
        class: 'SelectSearchField',
        placeholder: 'Region',
        lookupService: GetAllRegions,
        lookupMapping: (region) => {
          const { name, id } = region;
          return { optionText: name, id };
        },
        lookupFilter: (region) => region.isSpecialty === 'false'
      },
      {
        id: 'crs-userType-search-field',
        hidden: true,
        value: Roles.CRS,
        name: 'userType',
        class: 'InputSearchField'
      }
    ];
  },

  getSearchService() {
    return SearchInternalUser;
  },

  getGridView() {
    return AssessmentCRSGridView;
  },

  handleResponse(response) {
    this.mapRegionsToUsers(response);
  },

  mapRegionsToUsers(response) {
    _.each(response, (internalUser) => {
      internalUser.regionName = internalUser.regionNames;
    });
  }
});

export default SearchUsersModalView;
